module.exports = __webpack_public_path__ + "static/media/Apple_logo_black.ea341ff0.svg";